export const ADD_MODULE_REQUEST = "ADD_MODULE_REQUEST";
export const ADD_MODULE_SUCCESS = "ADD_MODULE_SUCCESS";
export const ADD_MODULE_FAILURE = "ADD_MODULE_FAILURE";

export const GET_MODULES_BY_COURSE_ID_REQUEST =
  "GET_MODULES_BY_COURSE_ID_REQUEST";
export const GET_MODULES_BY_COURSE_ID_SUCCESS =
  "GET_MODULES_BY_COURSE_ID_SUCCESS";
export const GET_MODULES_BY_COURSE_ID_FAILURE =
  "GET_MODULES_BY_COURSE_ID_FAILURE";

export const UPDATE_MODULE_APPROVAL_STATUS_REQUEST =
  "UPDATE_MODULE_APPROVAL_STATUS_REQUEST";
export const UPDATE_MODULE_APPROVAL_STATUS_SUCCESS =
  "UPDATE_MODULE_APPROVAL_STATUS_SUCCESS";
export const UPDATE_MODULE_APPROVAL_STATUS_FAILURE =
  "UPDATE_MODULE_APPROVAL_STATUS_FAILURE";

export const RESET_MODULE_APPROVAL_STATUS = "RESET_MODULE_APPROVAL_STATUS";

export const GET_MODULE_BY_ID_REQUEST = "GET_MODULE_BY_ID_REQUEST";
export const GET_MODULE_BY_ID_SUCCESS = "GET_MODULE_BY_ID_SUCCESS";
export const GET_MODULE_BY_ID_FAILURE = "GET_MODULE_BY_ID_FAILURE";

export const UPDATE_MODULE_ORDER_REQUEST = "UPDATE_MODULE_ORDER_REQUEST";
export const UPDATE_MODULE_ORDER_SUCCESS = "UPDATE_MODULE_ORDER_SUCCESS";
export const UPDATE_MODULE_ORDER_FAILURE = "UPDATE_MODULE_ORDER_FAILURE";

export const UPDATE_MODULE_REQUEST = "UPDATE_MODULE_REQUEST";
export const UPDATE_MODULE_SUCCESS = "UPDATE_MODULE_SUCCESS";
export const UPDATE_MODULE_FAILURE = "UPDATE_MODULE_FAILURE";

export const DELETE_MODULE_REQUEST = "DELETE_MODULE_REQUEST";
export const DELETE_MODULE_SUCCESS = "DELETE_MODULE_SUCCESS";
export const DELETE_MODULE_FAILURE = "DELETE_MODULE_FAILURE";
